import { render, staticRenderFns } from "./OrderBizStats.vue?vue&type=template&id=13deadc4&scoped=true"
import script from "./OrderBizStats.vue?vue&type=script&lang=js"
export * from "./OrderBizStats.vue?vue&type=script&lang=js"
import style0 from "./OrderBizStats.vue?vue&type=style&index=0&id=13deadc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13deadc4",
  null
  
)

export default component.exports